module.exports = __webpack_public_path__ + "img/img_teacher2.48ba3746.png";